import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { useAssetCatalogPaths } from '@/hooks/useAssetCatalogPaths'
import { FunctionForm } from '@/components/forms/FunctionForm'
import { useThemeColors } from '@/hooks/useThemeColors'
import { AssetCatalogShell } from '@/components/assetCatalog/AssetCatalogShell'

export default function FunctionCreatePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { path } = useAssetCatalogPaths()
  const handleDone = () => navigate(path('functions'))

  return (
    <AssetCatalogShell fillHeight={false}>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
      <Box minW={0} display="flex" flexDirection="column" overflow="hidden" flex="1">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create Function</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Add a new function for a machine type
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <FunctionForm onSuccess={handleDone} onCancel={handleDone} />
          </CardBody>
        </Card>
      </Box>
      </Box>
    </AssetCatalogShell>
  )
}
